import { render, staticRenderFns } from "./PlanoAcaoCard.vue?vue&type=template&id=3f28f346&scoped=true"
import script from "./PlanoAcaoCard.vue?vue&type=script&lang=js"
export * from "./PlanoAcaoCard.vue?vue&type=script&lang=js"
import style0 from "./PlanoAcaoCard.vue?vue&type=style&index=0&id=3f28f346&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f28f346",
  null
  
)

export default component.exports